// src/utils/loadGoogleMapsScript.js
let googleMapsLoading = false;
let googleMapsLoaded = false;
let callbacks = [];

export const loadGoogleMapsScript = (callback) => {
  if (googleMapsLoaded) {
    callback();
    return;
  }

  callbacks.push(callback);

  if (googleMapsLoading) {
    return;
  }

  googleMapsLoading = true;

  if (window.google && window.google.maps) {
    googleMapsLoaded = true;
    googleMapsLoading = false;
    callbacks.forEach(cb => cb());
    callbacks = [];
    return;
  }

  const script = document.createElement('script');
  script.src = `https://maps.googleapis.com/maps/api/js?key=AIzaSyDNyevW_K3I8Nk_6Rg6jntytgi0W0rNu58&libraries=places`;
  script.async = true;
  script.defer = true;
  
  script.onload = () => {
    googleMapsLoaded = true;
    googleMapsLoading = false;
    callbacks.forEach(cb => cb());
    callbacks = [];
  };

  script.onerror = () => {
    googleMapsLoading = false;
    console.error('Failed to load Google Maps script');
    callbacks = [];
  };

  document.head.appendChild(script);
};